import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';

export const AdminContainer = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <Outlet />
    </Box>
  );
};
